import { useQuery } from '@tanstack/react-query';
import { categoriesApi } from '../api';
import { CategoryFilterParams } from '../types/category.types';

export const useCategories = (params: CategoryFilterParams) => {
    return useQuery({
        queryKey: ['admin', 'categories', 'paged', params],
        queryFn: () => categoriesApi.getPaged(params),
        placeholderData: (previousData) => previousData,
    });
};

export const useAllCategories = () => {
    return useQuery({
        queryKey: ['admin', 'categories', 'all'],
        queryFn: () => categoriesApi.getAll(),
    });
};
